const DISPLAY_YEAR_MIN = 1900;
const DISPLAY_YEAR_MAX = 2100;

const isDisplayableUtcDate = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return false;
  const y = date.getUTCFullYear();
  const mo = date.getUTCMonth();
  const d = date.getUTCDate();
  const h = date.getUTCHours();
  const m = date.getUTCMinutes();
  if (![y, mo, d, h, m].every(Number.isFinite)) return false;
  if (y < DISPLAY_YEAR_MIN || y > DISPLAY_YEAR_MAX) return false;
  return true;
};

export const formatDateTimeToUTC = (dateString) => {
  if (dateString == null || dateString === '') return '';
  if (typeof dateString === 'string' && dateString.trim() === '') return '';
  if (typeof dateString === 'string') {
    const t = dateString.trim();
    if (t === 'null' || t === 'undefined') return '';
  }
  if (
    typeof dateString === 'object' &&
    dateString !== null &&
    !(dateString instanceof Date)
  ) {
    return '';
  }

  const date = new Date(dateString);
  if (!isDisplayableUtcDate(date)) return '';

  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const y2 = String(date.getUTCFullYear() % 100).padStart(2, '0');
  const formattedDate =
    `${String(date.getUTCMonth() + 1).padStart(2, '0')}-` + // Months are zero-based
    `${String(date.getUTCDate()).padStart(2, '0')}-` +
    `${y2}`;

  // Check if both hours and minutes are 00
  if (hours === 0 && minutes === 0) {
    return formattedDate; // Return only the date
  } else {
    return `${formattedDate} ${String(hours).padStart(2, '0')}:${String(
      minutes
    ).padStart(2, '0')}`; // Return time and date
  }
};

export const formatDateToUTC = (dateString) => {
  if (dateString == null || dateString === '') return '';
  if (typeof dateString === 'string' && dateString.trim() === '') return '';
  if (typeof dateString === 'string') {
    const t = dateString.trim();
    if (t === 'null' || t === 'undefined') return '';
  }
  if (
    typeof dateString === 'object' &&
    dateString !== null &&
    !(dateString instanceof Date)
  ) {
    return '';
  }

  const date = new Date(dateString);
  if (!isDisplayableUtcDate(date)) return '';

  const formattedDate =
    `${String(date.getUTCMonth() + 1).padStart(2, '0')}-` + // Months are zero-based
    `${String(date.getUTCDate()).padStart(2, '0')}-` +
    `${String(date.getUTCFullYear()).padStart(2, '0')} `;

  return formattedDate;
};

export const formatAppointmentTime = (dateString, timeStart, timeEnd) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const formattedDate =
    `${String(date.getUTCDate()).padStart(2, '0')}-` +
    `${String(date.getUTCMonth() + 1).padStart(2, '0')}-` + // Months are zero-based
    `${String(date.getUTCFullYear())}`;

  // Format time range if both start and end times are provided
  if (timeStart && timeEnd) {
    // Remove AM/PM and format to 24-hour format
    const startTime = timeStart.replace(/\s?(AM|PM)/gi, '');
    const endTime = timeEnd.replace(/\s?(AM|PM)/gi, '');
    return `${formattedDate} (${startTime}-${endTime})`;
  }

  // If only start time is provided, use it
  if (timeStart) {
    const startTime = timeStart.replace(/\s?(AM|PM)/gi, '');
    return `${formattedDate} (${startTime})`;
  }

  return formattedDate;
};

export const formatDateLocale = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const formatted = date.toLocaleString(undefined, {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  // Convert from MM/DD/YY, HH:MM to MM-DD-YY HH:MM
  return formatted.replace(/\//g, '-').replace(', ', ' ');
};
